import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../Shared/Button';
import SectionHeader from './SectionHeader';

const VideoSection = ({
  title,
  description,
  videoSrc,
  videoAlt = 'video',
  buttonText = 'Get Started',
  buttonVariant = 'primary',
  buttonClassName = 'w-full md:w-46',
  className = '',
  contentClassName = '',
  videoClassName = '',
  onClick,
}) => {
  return (
    <section
      className={`flex flex-col md:flex-row px-6 py-12 md:px-50 md:py-16 items-center gap-12 md:gap-14 ${className}`}
    >
      <div
        className={`flex flex-col items-start justify-center gap-5 flex-1 ${contentClassName}`}
      >
        <SectionHeader title={title} description={description} />
        <Button
          variant={buttonVariant}
          size="medium"
          className={buttonClassName}
          onClick={onClick}
        >
          {buttonText}
        </Button>
      </div>
      <div className={`w-full md:w-[576px] md:h-[352px] ${videoClassName}`}>
        <video
          src={videoSrc}
          alt={videoAlt}
          className="w-full h-full md:rounded-lg"
          controls
          playsInline
          muted
        />
      </div>
    </section>
  );
};

VideoSection.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  videoSrc: PropTypes.string.isRequired,
  videoAlt: PropTypes.string,
  buttonText: PropTypes.string,
  buttonVariant: PropTypes.string,
  buttonClassName: PropTypes.string,
  className: PropTypes.string,
  contentClassName: PropTypes.string,
  videoClassName: PropTypes.string,
  onClick: PropTypes.func,
};

export default VideoSection;
